{
  "addToFavorites": "إضافة إلى المفضلة",
  "alertCondition": "شرط التنبيه",
  "alertCreateFailed": "فشل إنشاء تنبيه السعر.",
  "alertCreated": "تم إنشاء تنبيه السعر.",
  "alertTargetValue": "قيمة هدف التنبيه",
  "allChains": "جميع الشبكات",
  "allMarkets": "الكل",
  "buyToken": "شراء العملة",
  "chain": "الشبكة",
  "change24h": "تغير 24 ساعة",
  "chart": "الرسم البياني",
  "coin": "العملة",
  "contract": "العقد",
  "contractCopied": "تم نسخ العقد.",
  "createAlert": "إنشاء تنبيه",
  "exchange": "المنصة",
  "favorite": "المفضلة",
  "filteredCoins": "العملات المفلترة",
  "gainers": "الرابحة",
  "holders": "حاملو العملة",
  "hot": "الأكثر تداولاً",
  "invalidAlertValue": "أدخل رقمًا موجبًا صالحًا.",
  "lastUpdated": "آخر تحديث",
  "liquidity": "السيولة",
  "live": "مباشر",
  "liveMarketBoard": "● لوحة السوق المباشرة",
  "loading": "جاري التحميل...",
  "loadingMarkets": "جار تحميل الأسواق...",
  "losers": "الخاسرة",
  "marketCap": "القيمة السوقية",
  "marketCategories": "فئات السوق",
  "marketStatus": "حالة السوق",
  "marketsSubtitle": "عملات معتمدة، عقود موثقة، رسوم بيانية مباشرة، سيولة وحجم تداول.",
  "marketsTitle": "أسواق EXALT",
  "noApprovedCoins": "لا توجد عملات معتمدة.",
  "noContractFound": "لم يتم العثور على عقد.",
  "percentChange": "يتحرك بنسبة %",
  "percentPlaceholder": "مثال: 5",
  "price": "السعر",
  "priceAbove": "يرتفع السعر فوق",
  "priceAlerts": "تنبيهات الأسعار",
  "priceBelow": "ينخفض السعر دون",
  "pricePlaceholder": "مثال: 50000",
  "refresh": "تحديث",
  "removeFromFavorites": "إزالة من المفضلة",
  "searchCoin": "ابحث عن عملة...",
  "staleMarketBoard": "⚠ قد تكون الأسعار قديمة",
  "status": "الحالة",
  "submittingAlert": "جارٍ الإنشاء...",
  "symbol": "الرمز",
  "telegram": "تيليجرام",
  "topGainer": "الأعلى ارتفاعاً",
  "topLoser": "الأعلى انخفاضاً",
  "totalListedCoins": "إجمالي العملات المدرجة",
  "trending": "الرائج",
  "volume": "الحجم",
  "volume24h": "حجم 24 ساعة",
  "website": "الموقع"
}